import { VanillaFrameworkOverrides } from 'ag-grid-community';
import { metadata } from 'aurelia-framework';

export class AureliaFrameworkOverrides extends VanillaFrameworkOverrides {
  override isFrameworkComponent(comp: any): boolean {
    if (!comp) {
      return false;
    }
    return !!metadata.getOwn(metadata.resource, comp);
  }
}
